import { createRouter, createWebHistory } from 'vue-router'

import eventBus from '@/plugins/eventBus'

import { setPageHeader } from '@/helpers/pageHelper'

// import routes from '@/config/routesConfig'
import BASE_LEVEL from '@/config/router/routerConfig.js'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: BASE_LEVEL,
})

// RISK(RISK-005)[S2/безопасность]: navigation guards отсутствуют — аутентификация, лицензия и права
// проверяются только условным рендером в компонентах, защищённые чанки грузятся до проверки.
// Нет router.onError (протухший динамический чанк после деплоя = «белый экран»). Страницы 404
// регистрирует приложение: [💻 notFoundRoutes.js](../../apps/ontrack/src/router/notFoundRoutes.js).
// Решение: единый guard-слой аутентификации/доступа + router.onError.
// Подробнее: docs/audit/04_risks_register.md (RISK-005), docs/audit/01_architecture_review.md §1.1
router.beforeEach((to, from, next) => {
	if (to.path !== from.path) {
		setPageHeader()
	}
	if (from.name !== undefined && from.name !== to.name && to.meta.isDynamicComponent) {
		eventBus.$emit('navigationRouterLinkLoading', {
			name: to.name,
			status: 'start',
		})
	}
	next()
})

router.beforeResolve((to, from, next) => {
	eventBus.$emit('navigationRouterLinkLoading', {
		name: to.name,
		status: 'end',
	})
	next()
})

export default router
